import '../styles/timer.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';

function Spinner(domElements, imgWidth, frameNum, startTime) {
    this.updateImg = function (frame) {
        if (this.$spinner) {
            var pos = (frame - this.numberOfFrames + 1) * this.imageWidth;
            this.$spinner.css('background-position', pos + 'px');
        }
    };

    this.update = function (diff) {
        var frame = Math.floor(diff / this.factor);
        this.updateImg(frame);
    };

    this.setStartState = function () {
        this.updateImg(0);
        if (this.$spinner) {
            this.$spinner.removeClass('refresh');
        }
    };

    this.setFinishedState = function () {
        this.updateImg(this.numberOfFrames - 1);
        if (this.$spinner) {
            this.$spinner.removeAttr('style');
            this.$spinner.addClass('refresh');
        }
    };

    this.refreshDomElements = function (domElements) {
        this.$spinner = domElements.$spinner;
    };

    this.refreshDomElements(domElements);
    this.imageWidth = imgWidth;
    this.numberOfFrames = frameNum;
    this.startTimeInMillisec = startTime * 1000;
    this.factor = this.startTimeInMillisec / this.numberOfFrames;
}

function Counter(domElements, startTime) {
    this.updateNumber = function (sec) {
        if (this.$counter) {
            this.$counter.text(sec);
        }
    };

    this.update = function (diff) {
        var sec = this.startTime - Math.floor(diff / 1000);
        this.updateNumber(sec);
        if (sec <= 0) {
            this.isFinished = true;
            this.updateNumber(0);
        }
    };

    this.setStartState = function () {
        this.updateNumber(this.startTime);
    };

    this.setFinishedState = function () {
        this.updateNumber(0);
    };

    this.refreshDomElements = function (domElements) {
        this.$counter = domElements.$counter;
    };

    this.refreshDomElements(domElements);
    this.startTime = startTime;
    this.isFinished = false;
}

function Title(domElements) {
    this.setStartState = function () {
        if (this.$initialTitle) {
            this.$initialTitle.css('display', 'block');
        }
        if (this.$timeupTitle) {
            this.$timeupTitle.css('display', 'none');
        }
    };

    this.setFinishedState = function () {
        if (this.$initialTitle) {
            this.$initialTitle.css('display', 'none');
        }
        if (this.$timeupTitle) {
            this.$timeupTitle.css('display', 'block');
        }
    };

    this.refreshDomElements = function (domElements) {
        this.$initialTitle = domElements.$initialTitle;
        this.$timeupTitle = domElements.$timeupTitle;
    };

    this.refreshDomElements(domElements);
}

function CountdownTimer(titleObj, spinnerObj, counterObj) {
    this.stop = function () {
        if (this.intervalVariable) {
            clearInterval(this.intervalVariable);
            this.intervalVariable = null;
        }
        this.counterObj.isFinished = false;
    };

    this.cancel = function (domElements) {
        if (domElements) {
            this.refreshDomElements(domElements);
        }
        this.stop();
        this.callback = null;
    };

    this.setStartState = function () {
        this.spinnerObj.setStartState();
        this.counterObj.setStartState();
        this.titleObj.setStartState();
    };

    this.setFinishedState = function () {
        this.spinnerObj.setFinishedState();
        this.counterObj.setFinishedState();
        this.titleObj.setFinishedState();
    };

    this.update = function () {
        var diff = $.now() - this.startedAt;
        this.spinnerObj.update(diff);
        this.counterObj.update(diff);
        if (this.counterObj.isFinished) {
            this.stop();
            this.setFinishedState();
            common.invoke(this.callback);
        }
    };

    this.start = function (finishHandler, domElements) {
        var instance = this;
        if (domElements) {
            this.refreshDomElements(domElements);
        }
        this.stop();
        this.setStartState();
        this.callback = finishHandler;
        this.startedAt = $.now();
        this.intervalVariable = setInterval(function () { instance.update(); }, this.interval);
    };

    this.refreshDomElements = function (domElements) {
        this.spinnerObj.refreshDomElements(domElements);
        this.counterObj.refreshDomElements(domElements);
        this.titleObj.refreshDomElements(domElements);
    };

    this.spinnerObj = spinnerObj;
    this.counterObj = counterObj;
    this.titleObj = titleObj;
    this.spinnerObj.setStartState();
    this.counterObj.setStartState();
    this.titleObj.setStartState();
    this.startedAt = 0;
    this.callback = null;
    this.intervalVariable = null;
    this.interval = 10;
}

function getTimerDomElements($timer) {
    var domElements = {
        $spinner: $timer.find('.uwr-timer-spinner'),
        $counter: $timer.find('.uwr-timer-counter'),
        $initialTitle: $timer.find('.uwr-timer-initial-title'),
        $timeupTitle: $timer.find('.uwr-timer-timeup-title')
    };
    return domElements;
}

function initTimer($timer) {
    var startTime = $timer.attr('data-start-time'),
        divIcon = '<div class="uwr-timer-spinner"><span class="uwr-timer-counter"></span></div>',
        frameNum = 100,
        imgWidth = 36,
        domElements,
        spinnerObj,
        counterObj,
        titleObj,
        timerObj;
    $timer.prepend(divIcon);
    domElements = getTimerDomElements($timer);
    spinnerObj = new Spinner(domElements, imgWidth, frameNum, startTime);
    counterObj = new Counter(domElements, startTime);
    titleObj = new Title(domElements);
    timerObj = new CountdownTimer(titleObj, spinnerObj, counterObj);
    $timer.data('timerObj', timerObj);
}

function initTimers() {
    $('.uwr-timer').each(function () {
        var $timer = $(this);
        if ($timer.data('initialized') !== true) {
            initTimer($timer);
            $timer.data('initialized', true);
        }
    });
}

/**
 * Initializes all Timers on the page. This function like all other API functions is called asynchronously.
 * The no-arg init() is automatically called when the page is loaded.
 * Dynamically added Timers need to be initialized by explicitly calling init().
 *
 * @param callback Javascript function object that is called when init() is finished. Optional parameter.
 */
export function init(callback) {
    initTimers();
    common.invoke(callback);
}

function startTimer($timer, handler) {
    if ($timer) {
        var timerObj = $timer.data('timerObj');
        if (timerObj) {
            timerObj.start(handler, getTimerDomElements($timer));
        }
    }
}

function cancelTimer($timer) {
    if ($timer) {
        var timerObj = $timer.data('timerObj');
        if (timerObj) {
            timerObj.cancel(getTimerDomElements($timer));
        }
    }
}

function startTimers(selector, handler) {
    $(selector).each(function () {
        startTimer($(this), handler);
    });
}

function cancelTimers(selector) {
    $(selector).each(function () {
        cancelTimer($(this));
    });
}

/**
 * Starts the countdown of the Timer.
 *
 * @param selector a CSS selector string pointing to one or more timer widgets to start.
 * @param timeUpHandler a function object that is called when the timer finishes.
 */
export function start(selector, timeUpHandler) {
    startTimers(selector, timeUpHandler);
}

/**
 * Stops the countdown of the Timer.
 *
 * @param selector a CSS selector string pointing to one or more timer widgets to cancel.
 */
export function cancel(selector) {
    cancelTimers(selector);
}

/**
 * DEPRECATED: Will be removed in the next MDP release. Use init(callback) instead.
 *
 * Registers a callback function to be executed when all Timers are initialized and ready
 * to use on the page. If more than one ready handler functions are added, the order of
 * execution might be different than the order of addition.
 *
 * @param callback Javascript function object
 */
export function ready(callback) {
    init(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/Timer/js/timer.js
// module id = 44
// module chunks = main